import React from 'react';
import { classNames } from '../utils/formatters';

const OrderTypePill = ({ orderType }) => {
  const inPerson = orderType === 'in-person';

  return (
    <span
      className={classNames(
        'pill border whitespace-nowrap px-2.5 py-1 text-[0.7rem]',
        inPerson ? 'bg-green-100 text-green-700 border-green-200' : 'bg-blue-100 text-blue-700 border-blue-200'
      )}
    >
      {inPerson ? 'In-Person' : 'Online'}
    </span>
  );
};

export default OrderTypePill;
